module.exports = __webpack_public_path__ + "img/9788985901628.c3fb1a8d.jpg";